var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEthereum(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4821",
    "data-name": "Group 4821",
    transform: "translate(-303 -476)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2182",
    "data-name": "Rectangle 2182",
    width: 25,
    height: 25,
    rx: 5,
    transform: "translate(303 476)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "polygon-matic-logo",
    transform: "translate(306.905 481.47)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ethereum-Logo.wine",
    transform: "translate(2.918 -2.216)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8191",
    className: "ethereum",
    "data-name": "Path 8191",
    d: "M125.166,12.648l.124.124,5.676-3.355L125.29,0l-.124.421Z",
    transform: "translate(-119.614)",
    fill: "#083f85",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8192",
    className: "ethereum",
    "data-name": "Path 8192",
    d: "M5.676,12.772V0L0,9.417Z",
    fill: "#083f85",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8193",
    className: "ethereum",
    "data-name": "Path 8193",
    d: "M126.386,244.381l.07.2,5.679-8-5.679,3.353-.07.085Z",
    transform: "translate(-120.78 -226.094)",
    fill: "#083f85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8194",
    className: "ethereum",
    "data-name": "Path 8194",
    d: "M0,236.585l5.676,8v-4.645Z",
    transform: "translate(0 -226.092)",
    fill: "#083f85",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8195",
    className: "ethereum",
    "data-name": "Path 8195",
    d: "M127.961,154.159v5.934l5.675-3.355Z",
    transform: "translate(-122.285 -147.322)",
    fill: "#083f85"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_8196",
    className: "ethereum",
    "data-name": "Path 8196",
    d: "M5.675,154.159,0,156.739l5.675,3.355Z",
    transform: "translate(0 -147.322)",
    fill: "#083f85",
    opacity: 0.9
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEthereum);
export default __webpack_public_path__ + "static/media/ethereum.b125557f.svg";
export { ForwardRef as ReactComponent };